import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	Edit: { k: 'userTags.edit', v: 'Edit Preferences' },

	Overflow: { k: 'userTags.selected.overflow', v: '${count} More', argNames: ['count'] },

	DialogTitle: { k: 'userTags.dialog.title', v: 'Edit Preferences' },

	Close: { k: 'userTags.dialog.close', v: 'Close' },

	Save: { k: 'userTags.dialog.save', v: 'Save and Close' }

});



// WEBPACK FOOTER //
// ./src/panels/tags/UserTags.labels.ts